var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreetView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 182,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.1,254.9c-1.9-1.9-4.4-2.9-7.1-2.9H220v-20h30c5.5,0,10-4.5,10-10v-80c0-5.5-4.5-10-10-10h-30v-30 c0-5.5-4.5-10-10-10h-40c-5.5,0-10,4.5-10,10v30H50c-2.7,0-5.2,1.1-7.1,2.9l-40,40c-3.9,3.9-3.9,10.2,0,14.1l40,40 c1.9,1.9,4.4,2.9,7.1,2.9h110v20h-30c-5.5,0-10,4.5-10,10v80c0,5.5,4.5,10,10,10h30v140H90c-5.5,0-10,4.5-10,10s4.5,10,10,10h200 c5.5,0,10-4.5,10-10s-4.5-10-10-10h-70V352h110c2.7,0,5.2-1.1,7.1-2.9l40-40c3.9-3.9,3.9-10.2,0-14.1L337.1,254.9z M180,112h20v20 h-20V112z M24.1,182l30-30H240v60H54.1L24.1,182z M180,232h20v20h-20V232z M200,492h-20V352h20V492z M325.9,332H140v-60h185.9 l30,30L325.9,332z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 302,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,120l20,50l30-100l-100,30L392,120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,0c-60.7,0-110,49.3-110,110v110c0,3.8,2.1,7.2,5.4,8.9c1.4,0.7,3,1.1,4.6,1.1c2.1,0,4.1-0.6,5.8-1.9 l35.2-25.3c17.6,11.2,37.9,17.1,59,17.1c60.7,0,110-49.3,110-110S462.7,0,402,0z M402,200c-19.3,0-37.7-6-53.2-17.4 c-3.5-2.6-8.2-2.6-11.8-0.1l-25,18V110c0-49.6,40.4-90,90-90s90,40.4,90,90S451.6,200,402,200z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetView);
export default __webpack_public_path__ + "static/media/street-view.a9244a81f2d9b72c3ba34b66432fc555.svg";
export { ForwardRef as ReactComponent };